import React, { ReactNode } from "react";

type PageLayoutProps = {
  header?: ReactNode;
  nav?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

const PageLayout = ({ header, nav, children, footer }: PageLayoutProps) => (
  <>
    {header}
    {nav}
    {children}
    {footer}
  </>
);

export default PageLayout;
